import { bi, } from "@helpers";
import * as AssetToken from "./assets/icons/coins";
import ImportedConfig from "./config.app.json";

import type { AnyToken, ExecutableToken, TokenInfo, SwappableToken, Token, ChainId, } from "@types";
import {
	ValidChainIds,
	type ValidChainId,
} from "@bracket/chainography";

export const config = ImportedConfig;

export const VALID_CHAINS = ValidChainIds;

export const swappableTokens: SwappableToken[] = [ "ETH", "wETH", ];

export const executableTokens: ExecutableToken[] = [ "wstETH", "eETH", "rETH", "ezETH", ];

/** all the tokens we know about */
export const allTokens: AnyToken[] = [ ...swappableTokens, ...executableTokens ];

export const depositableTokens: Token[] = [ "ETH" ];

/** Any Token available on the chain segment */
export const CHAINED_SYMBOLS: Record<ChainId, AnyToken[]> = {
	1: [
		"wstETH",
		"stETH",
		"weETH",
		"eETH",
		"rETH",
		"ezETH",
		// "wETH",
		"rsETH",
		"ankrETH",
		// "ETH",
	],
	42161: [
		"wstETH",
		"weETH",
		"rETH",
		"ezETH",
		"rsETH",
		"ankrETH",
		"wETH",
	],
}

/** Any Token available on the chain segment */
export const CHAINED_TOKEN_LABELS: Record<ChainId, AnyToken[]> = {
	1: [
		"wstETH",
		"stETH",
		"weETH",
		"eETH",
		"rETH",
		"ezETH",
		// "wETH",
		"rsETH",
		"ankrETH",
		"osETH",
		// "ETH",
		"stone",
		"cbETH",
		"sfrxETH",
	],
	42161: [
		"wstETH",
		"weETH",
		"rETH",
		"ezETH",
		"rsETH",
		"ankrETH",
		"osETH",
	],
	
}


export declare type SwappableToken = "ETH" | "wETH" | "WETH";

/** All token information from any chain */
export const TOKENS: Record<AnyToken, TokenInfo> = {
	"ETH":  { id: "ETH", "name": "ETH", icon: AssetToken.ETH, swappable: true, },
	"wETH": { id: "wETH", "name": "wETH", icon: AssetToken.ETH },
	"wstETH": { id: "wstETH", name: "wstETH", icon: AssetToken.STETH, },
	"weETH": { id: "weETH", name: "weETH", icon: AssetToken.EETH, },
	"rETH": { id: "rETH", name: "rETH", icon: AssetToken.RETH, },
	"ezETH": { id: "ezETH", name: "ezETH", icon: AssetToken.EZETH, },
	"stETH": { id: "stETH", name: "stETH", icon: AssetToken.STETH, },
	"eETH": { id: "eETH", name: "eETH", icon: AssetToken.EETH, },
};


let _chained_stakable_tokens;
export const CHAINED_STAKABLE_TOKENS: Record<ChainId, Record<AnyToken, TokenInfo>> = function() {
	if( !_chained_stakable_tokens ) {
		const result: any = { };
		for( const chain of VALID_CHAINS ) {
			result[chain] = { };
			for ( const token of swappableTokens ) {
				result[chain][token] = TOKENS[token];
			}
		}
		_chained_stakable_tokens = result;
	}
	return _chained_stakable_tokens;
}();


let _chained_swappable_tokens;
/** { [chaind id]: { [token]:  }} */
export const CHAINED_SWAPPABLE_TOKENS: Record<ChainId, Record<SwappableToken, TokenInfo>> = function() {
	if( !_chained_swappable_tokens ) {
		const result: any = { };
		for( const chain of VALID_CHAINS ) {
			result[chain] = { };
			for ( const token  of swappableTokens ) {
				result[chain][token] = TOKENS[token];
			}
		}
		_chained_swappable_tokens = result;
	}
	return _chained_swappable_tokens;
}();


let _chained_tokens;
export const CHAINED_TOKENS: Record<ChainId, Record<AnyToken, TokenInfo>> = function() {
	if(!_chained_tokens) {
		const result: any = { };
		for( const chain of VALID_CHAINS ) {
			result[chain] = { };
			for( const token of CHAINED_SYMBOLS[chain] ) {
				result[chain][token] = TOKENS[token];
			}
		}
		_chained_tokens = result;
	}
	return _chained_tokens;
}();




export const CHAINED_TOKENS_OLD: Record<ChainId, Map<ExecutableToken, TokenInfo>>  = {

	1: new Map<AnyToken, TokenInfo>([
		[ "wstETH", { id: "wstETH", name: "wrapped WSTETH", icon: AssetToken.STETH, } ],
		[ "weETH", { id: "weETH", name: "weETH", icon: AssetToken.EETH, } ],
		[ "rETH", { id: "wstETH", name: "rETH", icon: AssetToken.RETH, }],
		[ "ezETH", { id: "wstETH", name: "ezETH", icon: AssetToken.EZETH, }],
		[ "stETH", { id: "wstETH", name: "stETH", icon: AssetToken.STETH, } ],
		[ "eETH", { id: "weETH", name: "eETH", icon: AssetToken.EETH, } ],
	]),

	42161: new Map<ExecutableToken, TokenInfo>([
		[ "wstETH", { id: "wstETH", name: "wrapped WSTETH", icon: AssetToken.STETH, } ],
		[ "weETH", { id: "weETH", name: "weETH", icon: AssetToken.EETH, } ],
		[ "rETH", { id: "wstETH", name: "rETH", icon: AssetToken.RETH, }],
		[ "ezETH", { id: "wstETH", name: "ezETH", icon: AssetToken.EZETH, }],
	]),

	4216188: new Map<ExecutableToken, TokenInfo>([
		[ "wstETH", { id: "wstETH", name: "wrapped WSTETH", icon: AssetToken.STETH, } ],
		[ "weETH", { id: "weETH", name: "weETH", icon: AssetToken.EETH, } ],
		[ "rETH", { id: "wstETH", name: "rETH", icon: AssetToken.RETH, }],
		[ "ezETH", { id: "wstETH", name: "ezETH", icon: AssetToken.EZETH, }],
	]),

}



/** @deprecated - use the token map */
export const executableTokenMap = new Map<ExecutableToken, TokenInfo>([
	[ "wstETH", { id: "wstETH", name: "wrapped WSTETH", icon: AssetToken.STETH, } ],
	[ "weETH", { id: "weETH", name: "wETH", icon: AssetToken.EETH, } ],
	[ "rETH", { id: "wstETH", name: "rETH", icon: AssetToken.RETH, }],
	[ "ezETH", { id: "wstETH", name: "ezETH", icon: AssetToken.EZETH, }],
]);

export const executableTokenMapL2 = new Map<ExecutableToken, TokenInfo>([
	[ "wstETH", { id: "wstETH", name: "wrapped WSTETH", icon: AssetToken.STETH, } ],
	[ "weETH", { id: "weETH", name: "wETH", icon: AssetToken.EETH, } ],
	[ "rETH", { id: "wstETH", name: "rETH", icon: AssetToken.RETH, }],
	[ "ezETH", { id: "wstETH", name: "ezETH", icon: AssetToken.EZETH, }],
	[ "stETH", { id: "wstETH", name: "stETH", icon: AssetToken.STETH, } ],
	[ "eETH", { id: "weETH", name: "wETH", icon: AssetToken.EETH, } ],
]);





export const swappableTokenMap = new Map<SwappableToken, TokenInfo>([
	[ "ETH", { id: "ETH", name: "Ethereum", icon: AssetToken.ETH, } ],
	[ "wETH", { id: "wETH", name: "Wrapped Ethereum", icon: AssetToken.WETH, } ]
]);

export const transferToGasMap = new Map<Token, BigInt>([
	[ "ETH", bi(0.01) ]
]);

export const transferFromGasMap = new Map<Token, BigInt>([
]);
